import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ allow, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-charcoal-800">
        <div className="text-gold animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

export function defaultPathForRole(role) {
  switch (role) {
    case "admin":
    case "owner":
      return "/app/dashboard";
    case "kasir":
      return "/app/kasir";
    case "terapis":
      return "/app/earnings";
    default:
      return "/";
  }
}
